import api from "../../utils/authFetch"

export const getSandboxUserPredictions = async (payload) => {
    try{
        const response = await api.post(`${process.env.REACT_APP_BACKEND_URL}/prediction/admin/sandbox-customer/prediction`, payload)
        return response.data
    }catch(err){
        //  if (err.name === "AbortError" || err.name === "CanceledError")  return; 
        throw err.response?.data || err.message
    }
}
